module.exports = "<div class=\"content-wrapper\" style=\"min-height:1024px\">\r\n  <!---->\r\n  <!-- -->\r\n\r\n\r\n  <!-- Your Page Content Here -->\r\n  <!--<router-outlet></router-outlet>-->\r\n\r\n        <app-container></app-container>\r\n       \r\n</div>\r\n<!-- /.content-wrapper -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/shell/shell-templates/page-container.component.html
// module id = 1069
// module chunks = 22